'use strict';

module.exports = /^'?(\d{1,2})$/;


// WEBPACK FOOTER //
// ./~/sugar-date/date/var/ABBREVIATED_YEAR_REG.js